module.exports = __webpack_public_path__ + "img/arrow-right.fb071829.svg";